import { render, staticRenderFns } from "./ZusatzZweitwohnung.vue?vue&type=template&id=5de305fd&"
import script from "./ZusatzZweitwohnung.vue?vue&type=script&lang=js&"
export * from "./ZusatzZweitwohnung.vue?vue&type=script&lang=js&"
import style0 from "./ZusatzZweitwohnung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VRow})
